const IAABadge = ({ className = "", maxWidth = 125 }: { className?: string; maxWidth?: number }) => (
  <div className={className} style={{ width: "100%", maxWidth, maxHeight: maxWidth * 1.52 }}>
    <div style={{ position: "relative", paddingBottom: "152%", height: "auto", overflow: "hidden" }}>
      <iframe
        src="https://cdn2.yoshki.com/badgeframe?10"
        title="IAA Registered Adviser verification badge"
        loading="lazy"
        style={{ overflow: "hidden", border: 0, margin: 0, padding: 0, backgroundColor: "transparent", top: 0, left: 0, width: "100%", height: "100%", position: "absolute" }}
      />
    </div>
  </div>
);

export default IAABadge;
